import { Card, Stack, Typography, Divider, Chip, Box, TextField, Grid, Button, CircularProgress } from "@mui/material";
import ThemedPaper from "../core/ThemedPaper";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../state/store";
import { createProduct } from "../../state/slices/creations";
import { userSlice } from "../../state/slices/user";
import { useNavigate } from "react-router-dom";


const MAX_PRODUCT_NAME_LENGTH = 80;

export default function CreateProduct() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const idToken = useAppSelector(userSlice.selectors.selectIdToken) ?? '';

  useEffect(() => {

  });

  const [title, settitle] = useState<string>();

  if (!idToken) {
    return <CircularProgress />;
  }

  const isValid = title != null && title.length < MAX_PRODUCT_NAME_LENGTH;

  return (
    <ThemedPaper elevation={2} sx={{
      p: 2,
      minWidth: 500,
    }}>
    <Card variant="outlined" sx={{ marginBottom: 1 }}>
    <Box sx={{ p: 2 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Typography gutterBottom variant="h5" component="div">
    Create a new product
    </Typography>
    <Typography gutterBottom variant="h6" component="div">

    </Typography>
    </Stack>

    </Box>
    <Divider />
    <Box sx={{ p: 2 }}>
    <Stack direction="column" spacing={2}>
    <TextField
        label="Course Name" variant="filled" fullWidth
        error={!!title && (title.length > MAX_PRODUCT_NAME_LENGTH)}
        onChange={(e) => settitle(e.target.value)}
            />
      <Divider>Actions</Divider>
      <Stack direction="column" spacing={2}>
      <Button variant="contained"
        disabled={!isValid}
          onClick={() => {
            dispatch(createProduct({
              idToken,
              productDetails: {
                title: title ?? '',
              },
            })).then(() => navigate('/creations'));
          }}>
          Save
        </Button>
      </Stack>
    </Stack>
    </Box>
    </Card>
    </ThemedPaper>
  );
}